var _rect, _path, _path2, _path3, _path4, _path5, _rect2, _rect3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrCode4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 149,
    viewBox: "0 0 151 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.6765,
    y: 32.3345,
    width: 20.9466,
    height: 20.9925,
    rx: 10.4733,
    fill: "black",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.15 40.1235C94.0978 39.8637 87.6149 33.3528 87.3564 25.2969H102.15V40.1235Z",
    fill: "black",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6315 132.5C56.8894 124.929 62.9794 118.813 70.5467 118.554L70.5467 132.5L56.6315 132.5Z",
    fill: "black",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6681 118.545C33.4103 126.116 27.3202 132.232 19.7529 132.491L19.7529 118.545L33.6681 118.545Z",
    fill: "black",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.951 41.1401C126.519 41.3992 132.609 47.5155 132.867 55.0865H118.951V41.1401Z",
    fill: "black",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5552 101.71C71.8187 93.9587 78.1858 87.7555 86.0017 87.7555L86.3483 87.7555L86.3483 101.71L71.5552 101.71Z",
    fill: "black",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 103.15,
    y: 41.1316,
    width: 14.8015,
    height: 13.9549,
    fill: "black",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 71.5468,
    y: 117.545,
    width: 14.8346,
    height: 14.8015,
    transform: "rotate(-90 71.5468 117.545)",
    fill: "black",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3564 86.7558C87.6149 78.7 94.0978 72.189 102.15 71.9293V86.7558H87.3564Z",
    fill: "black",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M103.158 132.5C103.422 124.748 109.789 118.545 117.605 118.545L117.951 118.545L117.951 132.5L103.158 132.5Z",
    fill: "black",
    stroke: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8835 101.71C19.147 93.9587 25.514 87.7555 33.3299 87.7555L33.6765 87.7555L33.6765 101.71L18.8835 101.71Z",
    fill: "black",
    stroke: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M103.15 56.0864H117.943C117.685 64.1422 111.202 70.6532 103.15 70.9129V56.0864Z",
    fill: "black",
    stroke: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.142 102.711C101.883 110.766 95.4005 117.277 87.3484 117.537L87.3484 102.711L102.142 102.711Z",
    fill: "black",
    stroke: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3484 87.7556H102.141C101.878 95.5073 95.5109 101.711 87.695 101.711H87.3484V87.7556Z",
    fill: "black",
    stroke: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M132.867 118.545C132.609 126.116 126.519 132.232 118.951 132.491L118.951 118.545L132.867 118.545Z",
    fill: "black",
    stroke: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5917 87.7555C48.3339 95.3264 42.2438 101.443 34.6765 101.702L34.6765 87.7555L48.5917 87.7555Z",
    fill: "black",
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 23.375,
    y: 21,
    width: 43.5496,
    height: 43.6617,
    stroke: "black",
    strokeWidth: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode4);
export default __webpack_public_path__ + "static/media/qr-code-4.21ff78daf962ba1ab9c218296f3a7f25.svg";
export { ForwardRef as ReactComponent };